module.exports = __webpack_public_path__ + "static/media/leading-mental-health@3x.0f3fb6a1.png";